import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Process Manual Order API Call
 * @param {Object} orderData - Order details
 * @returns {Promise<Object>} - Response data from the API
 */
export const processManualOrder = async (payload) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.PROCESS_ORDER, payload);
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
